<template>
  <van-popup
    class="login-popup"
    :value="loginFlag"
    round
    position="bottom"
    @click-overlay="close"
    duration="0.2"
  >
    <img class="popup-btn" :src="icon_close" alt="" @click="close" />
    <div class="phone-wrapper" v-if="current === 'phone' && isNotEmptyObject(loginInfo)">
      <h5 class="login-title">{{ loginInfo.phoneLogin }}</h5>
      <input
        class="flex-center phone-input"
        type="tel"
        v-model="phone"
        :placeholder="loginInfo.phoneNumber"
        :maxlength="11"
      />
      <div class="agreement" @click="read = !read">
        <img :src="read ? icon_selected : icon_unselected" alt="" />
        <div class="compoct">
          <span>{{ loginInfo.agree }}</span>
          <span @click.stop="handlerGoServiceAgreement">{{ loginInfo.serviceTerms }}</span>
          <span>{{ loginInfo.and }}</span>
          <span @click.stop="handlerGoSelfAgreement">{{ loginInfo.privacyAgreement }}</span>
        </div>
      </div>
      <div
        class="login-btn flex-center"
        :class="{ disabled: !canSubmitPhone }"
        @click="submitPhone"
      >
        {{ loginInfo.LogIn }}
      </div>
    </div>
    <div class="code-wrapper" v-if="current === 'code' && isNotEmptyObject(messagesInfo)">
      <h5 class="login-title">
        {{ sms_type === 1 ? messagesInfo.enterMessageCode : messagesInfo.enterVoiceCode }}
      </h5>
      <p class="code-tip">
        <span class="code-phone">
          {{ hasSendSms ? messagesInfo.sendTo : messagesInfo.willBeSentTo }}
          {{
            phone.replace(/^(\d{3})(\d{4})(\d{4})$/g, (_, $1, $2, $3) => {
              return `${$1} ${$2} ${$3}`;
            })
          }}
        </span>
        <span class="code-time" v-show="showCount">
          <van-count-down ref="count" :time="time" format="ss" @finish="showCount = false" />
          <span>{{ messagesInfo.secondsSendAgain }}</span>
        </span>
        <span class="code-time" v-show="!showCount" @click="successSlide">{{
          messagesInfo.sendAgain
        }}</span>
      </p>
      <div class="code-input" @click="focusHiddenInput">
        <span class="code-input-item">
          <span>{{ code.split('')[0] }}</span>
          <span class="cursor" v-if="cursor && code.length === 0"></span>
        </span>
        <span class="code-input-item">
          <span>{{ code.split('')[1] }}</span>
          <span class="cursor" v-if="cursor && code.length === 1"></span>
        </span>
        <span class="code-input-item">
          <span>{{ code.split('')[2] }}</span>
          <span class="cursor" v-if="cursor && code.length === 2"></span>
        </span>
        <span class="code-input-item">
          <span>{{ code.split('')[3] }}</span>
          <span class="cursor" v-if="cursor && code.length === 3"></span>
        </span>
        <input
          style="font-size: 16px"
          v-model="code"
          type="tel"
          ref="hidden"
          class="code-input-hidden"
          @blur="cursor = false"
          @focus="cursor = true"
          :maxlength="4"
        />
      </div>
    </div>
    <van-popup v-model="voiceShow" class="voice-popup" v-if="isNotEmptyObject(messagesInfo)">
      <div class="voice-wrapper">
        <div class="voice-wrapper-con">{{ messagesInfo.voiceCode }}</div>
        <div class="voice-wrapper-close" @click="voiceShow = false">
          <span>{{ messagesInfo.know }}（</span>
          <van-count-down
            ref="voiceCountDown"
            :time="voiceTime"
            format="ss"
            @finish="voiceShow = false"
          />
          <span>s）</span>
        </div>
      </div>
    </van-popup>
  </van-popup>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { getSmsCode, login } from '@api/userchannel';
import { Toast } from 'vant';
import { TrackType } from '@utils/track';
import { trackData } from '../api';
import { LOCAL_STORAGE_TRACK, checkHkLoginPhone } from '@utils';

let showSlideCaptcha;
if (typeof window !== 'undefined') {
  let passport = require('@sftc/passport');
  showSlideCaptcha = passport.showSlideCaptcha;
}
export default {
  data() {
    return {
      icon_close: require('../images/close.png'),
      icon_back: require('../images/back.png'),
      icon_unselected: require('../images/unselected.png'),
      icon_selected: require('../images/selected.png'),

      phone: '',
      code: '',
      time: 60000,
      cursor: false,
      showCount: false,
      read: false,
      current: 'phone',
      hasSendSms: false,

      sms_type: 1,
      voiceTime: 8000,

      voiceShow: false
    };
  },
  computed: {
    ...mapState({
      loginFlag: state => state.loginFlag,
      urlQuery: state => state.urlQuery,
      city_name: state => state.city_name,
      platform: state => state.platform,
      advInfo: state => state.advInfo,
      jsonRules: state => state.jsonRules,
      lang: state => state.lang
    }),
    canSubmitPhone() {
      var CNPhone = this.phone.length === 11 && /^1[0-9]{10}$/g.test(this.phone);
      var HKPhone = this.phone.length === 8 && this.lang === 'zh_HK';
      var ENPhone = checkHkLoginPhone(this.phone) && this.lang === 'en';

      return (CNPhone || HKPhone || ENPhone) && this.read;
    },
    loginInfo() {
      return this.jsonRules.login;
    },
    messagesInfo() {
      return this.jsonRules.messages;
    },
    option() {
      return {
        platform: 'crm',
        host: 'https://passtc.sf-express.com',
        // host: 'http://10.210.40.59:8090',
        lang: this.lang === 'zh_HK' ? 'zh-Hant' : this.lang == 'en' ? 'en' : 'zh-Hans'
      };
    }
  },
  methods: {
    ...mapMutations(['setState']),
    init() {
      this.phone = '';
      this.code = '';
      this.showCount = false;
      this.read = false;
      this.current = 'phone';
    },
    isNotEmptyObject(obj) {
      return obj != null && typeof obj === 'object' && Object.keys(obj).length > 0;
    },
    close() {
      this.setState({
        loginFlag: false
      });
    },
    handlerGoServiceAgreement() {
      let url =
        this.lang === 'zh_HK'
          ? 'https://goappic.sf-express.com/static/html/privacyagreement.html#/?platform=market_userServiceAgent_HK&h=1'
          : this.lang == 'en'
          ? 'https://goappic.sf-express.com/static/html/privacyagreement.html#/?platform=market_userServiceAgent_en&h=1'
          : 'https://www.sf-cityrush.com/armor/agreement/e70b96db-5a1d-40a0-b257-fb0f26f11071.html';
      location.href = url;
    },
    handlerGoSelfAgreement() {
      let url =
        this.lang === 'zh_HK'
          ? 'https://goappic.sf-express.com/static/html/privacyagreement.html#/?platform=clite_merchant_tc&h=1'
          : this.lang == 'en'
          ? 'https://goappic.sf-express.com/static/html/privacyagreement.html#/?platform=clite_merchant_en&h=1'
          : 'https://www.sf-cityrush.com/armor/agreement/5a50e4f6-759b-4942-8426-13f19726ddb9.html';
      location.href = url;
    },

    submitPhone() {
      if (this.canSubmitPhone) {
        this.current = 'code';
      }
    },

    // 展示滑动验证码
    // showSlide() {
    //   window._PASSICSDK._config.host = 'https://passtc.sf-express.com';
    //   // window._PASSICSDK._config.host = 'http://10.210.40.47:8090';
    //   window._PASSICSDK.showSlide(this.successSlide);
    //   window._PASSICSDK._config.captchaValueCallback = this.successSlide;
    // },

    // 成功滑动回调
    async successSlide() {
      // 校验图形验证码 && 获取短信验证码
      const { closeModal, addSuccessStyle, addFailStyle } = await showSlideCaptcha(
        this.option,
        captchaValue => {
          getSmsCode({
            user_phone: this.phone,
            inviter_token: this.urlQuery.s,
            token: captchaValue,
            lang: this.lang
          }).then(
            res => {
              this.sms_type = res.sms_type;
              if (res.sms_type === 1) {
                Toast.success(this.messagesInfo.codeBeenSent);
              } else {
                this.voiceShow = true;
              }

              addSuccessStyle();
              this.againCount();
              this.hasSendSms = true;
              closeModal();
            },
            () => {
              // 验证码错误
              addFailStyle();
            }
          );
        }
      );
    },

    // 重新倒计时
    againCount() {
      this.showCount = true;
      this.$refs.count.reset();
    },

    focusHiddenInput() {
      this.$refs.hidden.focus();
    }
  },
  watch: {
    loginFlag(v) {
      if (!v) {
        this.init();
      }
    },
    current(v) {
      console.log(v);
      if (v === 'code') {
        this.successSlide();
      }
    },
    code(v) {
      console.log('start');
      if (v.length === 4) {
        this.$refs.hidden.blur();
        login({
          user_phone: this.phone,
          sms_code: v,
          inviter_token: this.urlQuery.s,
          city_name: this.city_name
        }).then(
          res => {
            if (res.coupon_list.length) {
              this.setState({
                couponHasSend: res.has_send,
                currentStatus: res.is_new ? 'new' : 'old'
              });
              console.log('byte');
              window.sfjsPoint.track('get_coupon_success'); // 领取成功
              const p = {
                type: this.advInfo.channel,
                click_id: this.advInfo.clickId,
                url: location.href,
                action_time: Date.now(),
                user_id: res.user_id,
                action_type: this.advInfo.channel === TrackType.tencent ? 'CLAIM_OFFER' : 'form',
                open_id: localStorage.getItem(LOCAL_STORAGE_TRACK) || '',
                action_param: JSON.stringify({
                  platform: this.platform
                })
              };
              trackData(p).then(res => {
                console.log(res, 'get coupon track');
              });
            } else {
              this.setState({
                currentStatus: 'fail'
              });
            }
            this.setState({
              loginFlag: false
            });
          },
          // -2为登录类报错，不关闭登录弹窗，其余报错关闭登录弹窗
          res => {
            if (res.data.errno !== -2) {
              this.setState({
                loginFlag: false
              });
            }
          }
        );
      }
    },

    voiceShow(v) {
      if (v) {
        this.$refs.voiceCountDown.reset();
      }
    }
  }
};
</script>
<style lang="less">
.login-popup {
  padding: 40px;
  height: 80%;
  border-radius: 20px 20px 0 0;
  overflow-y: unset;
  .popup-btn {
    position: absolute;
    width: 72px;
    height: 72px;
    left: 40px;
    top: -102px;
  }
  .login-title {
    margin-bottom: 40px;
    line-height: 67px;
    font-family: PingFangSC-Medium;
    font-size: 48px;
    color: #222222;
  }
  .login-btn {
    height: 100px;
    background: #e7091d;
    border-radius: 48px;
    font-family: PingFangSC-Medium;
    font-size: 36px;
    color: #ffffff;
    &.disabled {
      background: #e6e6e6;
    }
  }

  .phone-wrapper {
    input {
      width: 100%;
      height: 120px;
      margin-bottom: 40px;
      line-height: 45px;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #222222;
      border-bottom: 2px solid #e6e6e6;
      border-radius: 0;
    }
    .agreement {
      display: flex;
      margin-bottom: 80px;
      align-items: center;
      .compoct {
        display: inline-block;
      }
      img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
        vertical-align: middle;
      }
      span {
        line-height: 33px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #222222;
      }
    }
  }
  .code-wrapper {
    .code-tip {
      display: flex;
      align-items: center;
      height: 40px;
      margin-bottom: 40px;
      .code-phone {
        margin-right: 60px;
        font-family: PingFangSC-Regular;
        font-size: 28px;
        color: #999999;
      }
      .code-time,
      .van-count-down {
        line-height: 33px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #e7091d;
      }
      .van-count-down {
        display: inline-block;
      }
    }
    .code-input {
      display: flex;
      &-item {
        position: relative;
        text-align: center;
        margin-right: 50px;
        height: 120px;
        padding: 40px 0 12px;
        width: 90px;
        border-bottom: 2px solid #cccccc;
        font-family: PingFangSC-Regular;
        font-size: 48px;
        color: #222222;
        line-height: 67px;
        .cursor {
          position: absolute;
          width: 4px;
          height: 60px;
          background: #ed2812;
          left: 50%;
          transform: translateX(-50%);
          animation: bulingbuling 1s infinite linear;
        }
        @keyframes bulingbuling {
          0% {
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      }
      &-hidden {
        position: absolute;
        left: -100%;
        top: 0;
      }
    }
  }
}
</style>
<style lang="less">
#_sdk_mask,
#_sdk_modal {
  z-index: 999998 !important;
}
.van-toast {
  z-index: 999999 !important;
}
.van-popup.voice-popup {
  width: 640px;
  background: #ffffff;
  border-radius: 16px;
  height: auto;
  padding: 0;
  .voice-wrapper {
    &-con {
      padding: 64px 48px;
      font-family: PingFangSC-Medium;
      font-size: 34px;
      letter-spacing: -0.44px;
      color: #353535;
      line-height: 48px;
      border-bottom: 2px #e5e5e5 solid;
      text-align: center;
    }
    &-close {
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: center;

      span,
      .van-count-down {
        font-family: PingFangSC-Medium;
        font-size: 34px;
        color: #576b95;
      }
    }
  }
}
</style>
